import { defineStore } from 'pinia'
import { useFetch } from '@/modules/core/composables/useFetch'
import { Candidate } from '../types'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

export const useCandidateStore = defineStore('connecting/candidateStore', () => {
  const route = useRoute()
  const baseUrl = computed(() => `/v4/${route.params.slug || 'connections'}/connecting/candidates`)
  const items = ref<Candidate[]>([])
  const candidates = computed(() => items.value)

  // queries
  const fetchCandidate = async (candidateId: string) => {
    const data = await useFetch(`${baseUrl.value}/${candidateId}`).get<Candidate>()
    items.value = [...items.value.filter((c) => c.id.toString() !== candidateId.toString()), data]
  }
  // commands

  const createCandidate = async (candidate: Candidate) => {
    await useFetch(baseUrl.value).post({ candidate })
  }

  const updateCandidate = async (candidate: Candidate) => {
    await useFetch(`${baseUrl.value}/${candidate.id}`).post({ candidate })
    await fetchCandidate(candidate.id.toString())
  }

  // helpers

  const getCandidate = (id: string): Candidate | undefined => {
    return items.value.find((candidate) => candidate.id.toString() === id.toString())
  }

  return {
    fetchCandidate,

    createCandidate,
    updateCandidate,

    getCandidate,
  }
})
